module.exports = __webpack_public_path__ + "static/olle-01877de02c89dab4e6d03487f426cf22.jpg";